import axios from "axios";
import { get_AI_URI_BASE } from "../configs/env";

const host = get_AI_URI_BASE();

export interface LogLevel {
  level: "debug" | "info" | "warning" | "warn" | "error" | "critical";
}

export interface LogData {
  [key: string]: any;
}

export interface LogMessage extends LogLevel {
  data: LogData;
}

export interface LogResponse {
  status: string;
  message: string;
}

export const sendLog = async (
  level: LogLevel["level"],
  data: LogData,
  token: string,
): Promise<LogResponse> => {
  try {
    const url = `${host}/logger/log`;
    const response = await axios.post<LogResponse>(
      url,
      {
        level,
        data,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    // never console.error(error) here: the AxiosError carries config.headers,
    // i.e. the caller's bearer token
    console.error(
      "sendLog failed:",
      axios.isAxiosError(error) ? error.message : error,
    );
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.detail || "Failed to send log message",
      );
    }
    throw error;
  }
};
